// extracted by mini-css-extract-plugin
export default {"formItem":"DzSaqX4JheYQbp7s8eEH","label":"ZIpckovIssfPBqGOafER","required":"xB3u9duWxG7yYUKdvZZy","requiredMark":"CD157jVqh10jHdNBxvvg","helperText":"iTRbGqtGLGgRCVzjBL8A"};